
import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/msalConfig";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Login() {
  const { instance, accounts, inProgress } = useMsal();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const isAuthenticated = accounts && accounts.length > 0;

  /* ================= AUTO REDIRECT ================= */
  useEffect(() => {
    if (inProgress !== "none") return;

    if (isAuthenticated) {
      navigate("/", { replace: true });
    } else {
      setLoading(false);
    }
  }, [isAuthenticated, inProgress, navigate]);

  /* ================= LOGIN ================= */
  const handleLogin = async () => {
    setError("");

    try {
      // ✅ ALWAYS use redirect (enterprise safe)
      await instance.loginRedirect(loginRequest);
    } catch (err) {
      console.error("Login failed", err);
      setError("Login failed. Please try again.");
    }
  };

  /* ================= UI ================= */
  if (loading) {
    return (
      <div style={styles.loader}>
        <div style={styles.spinner}></div>
        <p>Checking authentication...</p>
      </div>
    );
  }

  return (
    <div style={styles.root}>
      <div style={styles.card}>
        <img src={logo} alt="CFP" style={styles.logo} />

        <h2 style={styles.title}>
          CFP Document Management Portal
        </h2>

        <p style={styles.subtitle}>
          Secure enterprise document upload, search and policy management.
        </p>

        {error && <div style={styles.error}>{error}</div>}

        <button style={styles.button} onClick={handleLogin}>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const styles = {
  root: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #1e293b, #0f172a)",
  },

  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "12px",
    width: "380px",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    animation: "fadeIn 0.5s ease",
  },

  logo: {
    width: "80px",
    marginBottom: "20px",
  },

  title: {
    marginBottom: "10px",
  },

  subtitle: {
    fontSize: "14px",
    color: "#64748b",
    marginBottom: "20px",
  },

  button: {
    width: "100%",
    padding: "12px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "500",
    transition: "0.2s",
  },

  error: {
    background: "#fee2e2",
    color: "#b91c1c",
    padding: "8px",
    borderRadius: "6px",
    marginBottom: "10px",
    fontSize: "13px",
  },

  loader: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  },

  spinner: {
    width: "30px",
    height: "30px",
    border: "4px solid #e2e8f0",
    borderTop: "4px solid #2563eb",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};